import { toastsAtom } from '@/global-store';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

export function useNotification() {
    const { t } = useTranslation();
    const setToasts = useSetAtom(toastsAtom);

    const show = (message, severity, duration) => {
        setToasts(prev => { console.log(prev); return[
            ...prev,
            {
                message: message || t('errorOccurred'),
                severity,
                key: new Date().getTime(),
                duration,
            },
        ]});
    };

    return {
        info(message, duration) {
            show(message, 'info', duration);
        },
        success(message, duration) {
            show(message, 'success', duration);
        },
        warning(message, duration) {
            show(message, 'warning', duration);
        },
        error(message, duration) {
            show(message, 'error', duration);
        },
    };
}
